


























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';

@Component
export default class CurrencyView extends Vue {
  public items: Common.Currency[] = new Array(0);
  public params: Common.CurrencyQuery = new Common.CurrencyQuery();
  public importQuery = new Common.ImportQuery('通貨', 'Currency');
  public exportQuery = new Common.ExportQuery('通貨', this.params);
  @Prop() public auditNo:string;

  public MasterBaseStatus = Common.MasterBaseStatus;
  

  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'code', text: 'コード' },
    { value: 'name', text: '名称' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },
  ];

  public created() {
    // 検索条件を設定する
    if(this.auditNo) {
      this.params.auditNo = this.auditNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
  }
  
  public async onCreate(obj: Common.Currency) {
    const workflows = this.$api.formatter.getOptions('workflow_masterBase');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  public workflowRequired(item: Common.Currency):boolean {
    if(item.state != Common.MasterBaseStatus.NotPosted) return false;
    var workflows = this.$api.formatter.getOptions('workflow_masterBase');
    return workflows.length > 0;
  }
}
